<template>
  <div>
    <div class="app-modal__grid two-columns payment-general-timing-grid">
      <div v-if="showInvoiceDate" class="app-modal-field">
        <span>{{ text.fields.invoiceDate }}</span>
        <VueDatePicker
          v-model="form.expenseDate"
          class="app-modal-datepicker"
          menu-class-name="app-modal-datepicker-menu"
          :placeholder="text.placeholders.date"
          :disabled="!canEditExpenseDate"
          :enable-time-picker="false"
          auto-apply
          locale="es-MX"
          format="dd/MM/yyyy"
          hide-input-icon
          :show-now-button="true"
          :now-button-label="text.nowButton"
        />
      </div>

      <div class="app-modal-field">
        <span>{{ text.fields.paymentDate }}</span>
        <VueDatePicker
          v-model="form.paymentDate"
          class="app-modal-datepicker"
          menu-class-name="app-modal-datepicker-menu"
          :placeholder="text.placeholders.date"
          :disabled="!canEditPaymentDate"
          :enable-time-picker="false"
          auto-apply
          locale="es-MX"
          format="dd/MM/yyyy"
          hide-input-icon
          :show-now-button="true"
          :now-button-label="text.nowButton"
        />
      </div>
    </div>

    <div class="app-modal__grid two-columns payment-concept-grid">
      <label class="app-modal-field full-width">
        <span>{{ text.fields.concept }}</span>
        <textarea
          v-model.trim="form.concept"
          class="form-control app-modal-field__textarea"
          :disabled="!canEditConcept"
          :class="{ 'is-invalid': hasFieldError('concept') }"
          rows="3"
          :placeholder="text.placeholders.concept"
          @blur="touchField('concept')"
        ></textarea>
        <div class="invalid-feedback d-block" v-if="hasFieldError('concept')">
          <span v-if="v$.form.concept.$errors.length">
            {{ v$.form.concept.$errors[0].$message }}
          </span>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import { PAYMENTS_TEXT } from '@/texts/catalog/payments';

const SCHEDULE_TEXT = PAYMENTS_TEXT.planModal.schedule;

export default {
  name: 'PaymentPlanGeneralScheduleBlock',
  components: {
    VueDatePicker,
  },
  data() {
    return {
      text: SCHEDULE_TEXT,
    };
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    firstInstallmentOptions: {
      type: Array,
      default: () => [],
    },
    showInvoiceDate: {
      type: Boolean,
      default: true,
    },
    canEditExpenseDate: {
      type: Boolean,
      default: true,
    },
    canEditPaymentDate: {
      type: Boolean,
      default: true,
    },
    canEditConcept: {
      type: Boolean,
      default: true,
    },
    hasFieldError: {
      type: Function,
      required: true,
    },
    touchField: {
      type: Function,
      required: true,
    },
    v$: {
      type: Object,
      default: null,
    },
  },
  methods: {
    // Keep methods section for future schedule utilities.
  },
};
</script>

<style scoped>
.app-modal__grid.two-columns.payment-general-timing-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 12px;
}

.app-modal__grid.two-columns.payment-concept-grid {
  margin-top: 16px;
}

@media (max-width: 1200px) {
  .app-modal__grid.two-columns.payment-general-timing-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 700px) {
  .app-modal__grid.two-columns.payment-general-timing-grid {
    grid-template-columns: 1fr;
  }
}
</style>
